<template>
  <div>
    <v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
    <div v-else-if="profileSection">
      <UserInfo @toggleToPublicInfo="toggleToPublicInfo" :isPublicButton="true" :userInfo="profileSection.personalInformation"/>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import UserInfo from "@/components/User/UserInfo.vue";

export default {
  name: 'PersonalProfileInfo',
  components: {UserInfo},
  data(){
    return {
      attrs: {
        elevation: 0,
      },
    }
  },
  methods: {
    ...mapActions('app',['setPageTitle']),
    ...mapActions('auth',['getProfileSection', 'clearProfileSection']),
    toggleToPublicInfo(){
      return this.$router.push({
        name: 'public-information',
      });
    }
  },
  computed: {
    ...mapGetters('auth',['profileSection','profileSectionLoading','profileSectionError']),
  },
  mounted () {
    this.setPageTitle('Personal Information');
  },
  created () {
    this.getProfileSection('personalInformation')
  },
  beforeDestroy () {
    this.setPageTitle('');
    this.clearProfileSection();
  }
}

</script>

<style lang="scss">

</style>